import { Container } from "@mui/material";

export default function PolitykaPrywatnosci() {
  return (
    <div className="max-w-3xl mx-auto p-6 leading-relaxed text-gray-800">
      <Container>
        <h1 className="text-2xl font-bold mb-6">Polityka Prywatności</h1>

        <section className="mb-4">
          <p>
            Administratorem danych osobowych jest właściciel serwisu
            <strong> twojaopiekunka.pl</strong>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            Cel przetwarzania danych:
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              Założenie i prowadzenie konta opiekunki, pielęgniarki lub
              fizjoterapeuty w serwisie.
            </li>
            <li>
              Publikacja profilu opiekunki, pielęgniarki lub fizjoterapeuty.
            </li>
            <li>
              Umożliwienie kontaktu ze strony osób poszukujących opieki lub
              usług związanych z opieką i rehabilitacją.
            </li>
            <li>
              Obsługa zapytań i zapewnienie prawidłowego działania serwisu.
            </li>
          </ul>
          <p className="mt-2 text-sm italic">
            Podanie danych jest dobrowolne, ale niezbędne do korzystania z
            funkcjonalności serwisu.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            Udostępnianie i przechowywanie:
          </h2>
          <p className="mb-2">
            Dane mogą być udostępniane użytkownikom serwisu (w zakresie
            opublikowanego profilu) oraz podmiotom wspierającym działanie
            serwisu, takim jak dostawcy hostingu i usług IT.
          </p>
          <p>
            <strong>Okres przechowywania:</strong> Dane są przechowywane przez
            czas posiadania konta lub do momentu usunięcia konta, z
            uwzględnieniem sytuacji, w których dalsze przechowywanie danych jest
            wymagane przez przepisy prawa.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">Twoje prawa:</h2>
          <p className="mb-2">Przysługuje Ci prawo do:</p>
          <ul className="list-disc pl-5 grid grid-cols-1 md:grid-cols-2 gap-1">
            <li>Dostępu do swoich danych i ich sprostowania.</li>
            <li>Usunięcia danych („prawo do bycia zapomnianym”).</li>
            <li>Ograniczenia przetwarzania danych.</li>
            <li>Przenoszenia danych.</li>
            <li>Wniesienia sprzeciwu wobec przetwarzania danych.</li>
            <li>
              Wycofania zgody, jeśli przetwarzanie odbywa się na jej podstawie.
            </li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            Usunięcie danych osobowych
          </h2>
          <p className="mb-2">
            Aby usunąć swoje dane osobowe oraz konto w serwisie, napisz
            wiadomość na adres:
          </p>
          <p className="mb-2">
            <strong>
              <a
                href="mailto:kontakt@allworks.pl?subject=Usuni%C4%99cie%20danych%20osobowych"
                className="underline"
              >
                kontakt@allworks.pl
              </a>
            </strong>
          </p>
          <p className="mb-2">
            W tytule wiadomości wpisz dokładnie:
            <strong> Usunięcie danych osobowych</strong>.
          </p>
          <p>
            Wniosek zostanie rozpatrzony zgodnie z obowiązującymi przepisami o
            ochronie danych osobowych. Niektóre dane mogą być przechowywane
            dłużej, jeżeli wymagają tego przepisy prawa.
          </p>
        </section>

        <footer className="border-t pt-4 mt-6 text-sm text-gray-600">
          <p className="mb-2">
            Zgodę można wycofać w dowolnym momencie poprzez kontakt z
            administratorem. Wycofanie zgody nie wpływa na zgodność z prawem
            przetwarzania dokonanego przed jej wycofaniem.
          </p>
          <p>
            W przypadku naruszenia przepisów o ochronie danych osobowych
            przysługuje prawo wniesienia skargi do
            <strong> Prezesa Urzędu Ochrony Danych Osobowych</strong>.
          </p>
        </footer>
      </Container>
    </div>
  );
}
